import { createFeatureSelector } from '@ngrx/store';

export const loyaltyIntroductionPagesImagesState = createFeatureSelector<OLO.State, OLO.State.LoyaltyIntroductionPageImage[]>('loyaltyIntroductionPagesImages');
